import React from 'react'
import PropTypes from 'prop-types'

const TriggerAndActionCounter = ({ actions }) => {
  const twitterTriggers = actions.reduce(function (allTriggers, value) {
    if (
      value.platform &&
      (value.platform.toLowerCase() === 'twitter' ||
        value.platform.toLowerCase() === 'instagram')
    ) {
      return allTriggers.concat(value.triggers)
    }
    return allTriggers
  }, [])

  // only count primary triggers
  const triggerCount = twitterTriggers.reduce(
    (a, b) => a + (b.primary ? 1 : 0),
    0
  )

  const actionsCount = actions.reduce(function (sum, value) {
    if (
      value.platform &&
      (value.platform.toLowerCase() === 'twitter' ||
        value.platform.toLowerCase() === 'instagram')
    ) {
      return sum + value.failure.length + value.success.length
    }
    return sum
  }, 0)

  return (
    <div className='br-experience-trigger-action'>
      Experience has{' '}
      {`${triggerCount} ${triggerCount === 1 ? 'trigger' : 'triggers'} `}
      and {`${actionsCount} ${actionsCount === 1 ? 'action' : 'actions'}`}
    </div>
  )
}

TriggerAndActionCounter.propTypes = {
  actions: PropTypes.array.isRequired
}

TriggerAndActionCounter.displayName = 'TriggerAndActionCounterComponent'

export default TriggerAndActionCounter



// WEBPACK FOOTER //
// ./src/pages/my-experiences/experience/trigger-and-action-counter/index.js